import { SortDirection } from '@angular/material/sort';
import { IVehicleAssignmentFilterParams } from '../../../../interfaces/vehicles/vehicle-interfaces';

/**
 * Vehicle assignment filter model
 *
 * @version
 * 4.71.0 OAUI-693 Tidy and remove duplicated code
 * 4.70.0 OAUI-681 Improve vehicle assignment pagination to allow sorting
 * 4.70.0 OAUI-678 Build "Driver Assignment" UI
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
export class VehicleAssignmentFilterModel {
  private readonly dateStart?: Date;
  private readonly dateEnd?: Date;
  private readonly page?: number | null;
  private readonly pageSize?: number | null;
  private readonly sortKey?: string;
  private readonly sortDir?: SortDirection;
  private readonly driver?: any;
  private readonly vehicle?: any;

  /**
   * Constructor
   * @since 4.70.0
   */
  constructor(
    dateStart: Date,
    dateEnd: Date,
    page: number,
    pageSize: number,
    sortKey: string,
    sortDir: SortDirection,
    driver: any,
    vehicle: any,
  ) {
    this.dateStart = dateStart;
    this.dateEnd = dateEnd;
    this.page = page;
    this.pageSize = pageSize;
    this.sortKey = sortKey;
    this.sortDir = sortDir;
    this.driver = driver;
    this.vehicle = vehicle;
  }

  /**
   * Get serialized filters
   * @since 4.70.0
   */
  getSerialized(): IVehicleAssignmentFilterParams {
    // Core Filters
    const result: any = {
      page: this.page ? this.page : null,
      pageSize: this.pageSize ? this.pageSize : null,
      sortKey: this.sortKey ? this.sortKey : null,
      sortDir: this.sortDir ? this.sortDir : null,
      userId: this.driver ? this.driver.id : null,
      vehicleId: this.vehicle ? this.vehicle.id : null,
    };
    // Date Start Filters
    if (this.dateStart) {
      result.dateStart = this.dateStart;
    }
    // Date End Filters
    if (this.dateEnd) {
      result.dateEnd = this.dateEnd;
    }
    return result;
  }
}
